module.exports = __webpack_public_path__ + "img/sample.00994831.png";